import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import ZoneService from "../../../../../services/ZoneService";
import QrCodeGroupingService from "../../../../../services/QrCodeGroupingService";

const AddQrCodeGroupingModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		quantity: "",
		zone: "",
		price_per: "hour",
		price: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const zoneService = new ZoneService();
	const qrCodeGroupingService = new QrCodeGroupingService();

	useEffect(() => {
		Promise.all([zoneService?.getList()]).then((res) => {
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
						floor: Number(info?.floor),
					};
				});
				setZonesOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					name: item?.name,
					quantity: item?.quantity,
					zone: {
						label: lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar,
						value: item?.zone_id,
					},
					floor: {
						label: item?.floor_number,
						value: item?.floor_number,
					},
					price: item?.price,
					price_per: item?.price_per,
				});
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.zone?.value) {
			toast.error("Complete All Phases");
			return;
		}
		let data = {
			name: formData?.name,
			quantity: Number(formData?.quantity),
			zone_id: formData?.zone?.value,
			price: Number(formData?.price),
			price_per: formData?.price_per,
		};

		setLoading(true);
		if (isAdd) {
			qrCodeGroupingService
				.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			qrCodeGroupingService
				.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.qr_code_grouping}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.english}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({
										...formData,
										name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Quantity */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.quantity}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.arabic}
								bsSize="lg"
								name="quantity"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.quantity}
								onChange={(e) =>
									setFormData({
										...formData,
										quantity: e.target.value,
									})
								}
							/>
						</Col>
						{/* Zone */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.zone}
								<span className="star-require">*</span>
							</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) => setFormData({ ...formData, zone: e })}
							/>
						</Col>
						{/* Price */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.price}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.arabic}
								bsSize="lg"
								name="price"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.price}
								onChange={(e) =>
									setFormData({
										...formData,
										price: e.target.value,
									})
								}
							/>
						</Col>
						{/* Price Per */}
						<Col md={6}>
							<label className="text-label">{Translate[lang]?.price_per}</label>
							<div className="d-flex gap-16 mt-2">
								<label className="mb-0">
									<input
										type="radio"
										name="price_per"
										value="price_per"
										checked={formData?.price_per === "day"}
										onChange={() =>
											setFormData({ ...formData, price_per: "day" })
										}
									/>{" "}
									{Translate[lang]?.day}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="price_per"
										value="price_per"
										checked={formData?.price_per === "hour"}
										onChange={() =>
											setFormData({ ...formData, price_per: "hour" })
										}
									/>{" "}
									{Translate[lang]?.hour}
								</label>
								<label className="mb-0">
									<input
										type="radio"
										name="price_per"
										value="price_per"
										checked={formData?.price_per === "event_schedule"}
										onChange={() =>
											setFormData({ ...formData, price_per: "event_schedule" })
										}
									/>{" "}
									{Translate[lang]?.one_time_price}
								</label>
							</div>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.qr_code_grouping}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddQrCodeGroupingModal;
